import permissions from "@/UserPermissions/PermissionGroups";

export default [
  {
    //Dummy-item to resolve permissions on nav-items
    title: "",
    route: "",
    icon: "",
    display: false,
  },
  {
    header: "Min portfölj",
  },
  // {
  //   title: 'Startsida',
  //   route: 'home',
  //   icon: 'HomeIcon',
  // },
  {
    title: "Nyheter",
    route: "news-feed",
    icon: "BookOpenIcon",
    permissions: permissions.Permissions.READ_NEWS,
  },
  // {
  //   title: 'Kalender',
  //   route: 'calendar',
  //   icon: 'CalendarIcon',
  //   permissions: permissions.Permissions.READ_CALENDAR
  // },
  {
    title: "Min presentation",
    route: { name: "about-me", params: { type: "about-me" } },
    icon: "UserIcon",
    permissions: permissions.Permissions.READ_ABOUTME,
  },
  {
    title: "Min information",
    route: "search-articles",
    icon: "FileTextIcon",
    permissions: permissions.Permissions.READ_ARTICLE,
  },
  {
    title: "Kommunikationspass",
    route: "communication-articles",
    icon: "MessageSquareIcon",
    permissions: permissions.Permissions.READ_ARTICLE,
  },
  {
    title: "Kontakter",
    route: "contacts",
    icon: "UsersIcon",
    permissions: permissions.Permissions.READ_CONTACT,
  },
  {
    title: "Viktig information",
    route: "information-articles",
    icon: "AlertCircleIcon",
    permissions: permissions.Permissions.READ_ARTICLE,
  },
  {
    title: "Inställningar",
    route: "settings",
    icon: "SettingsIcon",
    permissions: permissions.PermissionGroups.Admin.Permissions,
  },
  // {
  //   title: 'temp [behörighets räknare]',
  //   route: 'permissions-calculator',
  //   icon: 'UsersIcon',
  //   permissions: permissions.PermissionGroups.Admin.Permissions
  // }
];
